import React, { useState } from "react";
import {
  Container,
  ResultBadge,
  SubRow,
  SubTable,
  Table,
  Title,
  ToggleButton,
} from "./styled";
import { toJS } from "mobx";

const VSRecord = ({ data }) => {
  return (
    <Container>
      <Title>
        상대전적
        <span>
          ※ 시즌 최근 5경기까지만 노출되며 배당률 및 기준점은 배트맨을 기준으로
          합니다.
        </span>
      </Title>

      <Table>
        <colgroup>
          <col width={80} />
          <col width={120} />
          <col width={49} />
          <col width={22} />
          <col width={49} />
          <col width={120} />
          <col width={200} />
        </colgroup>
        <thead>
          <tr>
            <th>경기일</th>
            <th>홈팀</th>
            <th colSpan={3}>점수</th>
            <th>원정팀</th>
            <th>결과</th>
          </tr>
        </thead>
        <tbody>
          {data.map((value, key) => {
            return <VSRow key={key} item={value} />;
          })}
        </tbody>
      </Table>
    </Container>
  );
};

const VSRow = ({ item }) => {
  const { teamsData, oddsData, date } = item;
  const [viewSub, setViewSub] = useState(false);

  const handleToggleSub = () => {
    setViewSub(!viewSub);
  };
  return [
    <tr key={"row"} onClick={handleToggleSub} className={viewSub ? "on" : ""}>
      <td>{date}</td>
      <td>{teamsData.home.name}</td>
      <td className={teamsData.home.winner ? "winner" : ""}>
        {teamsData.home.score}
      </td>
      <td>:</td>
      <td className={teamsData.away.winner ? "winner" : ""}>
        {teamsData.away.score}
      </td>
      <td>{teamsData.away.name}</td>
      <td>
        {oddsData.winLose.home && (
          <ResultBadge result={oddsData.winLose.home.result}>
            {oddsData.winLose.home.result === "WIN" && "홈승"}
            {oddsData.winLose.home.result === "DRAW" && "무승부"}
            {oddsData.winLose.home.result === "LOSS" && "홈패"}
          </ResultBadge>
        )}
        {oddsData.handicap.home && (
          <ResultBadge result={oddsData.handicap.home.result}>
            {oddsData.handicap.home.result === "HANDICAP_WIN" && "핸디승"}
            {oddsData.handicap.home.result === "HANDICAP_DRAW" && "핸디무"}
            {oddsData.handicap.home.result === "HANDICAP_LOSS" && "핸디패"}
          </ResultBadge>
        )}
        {oddsData.unover.home && (
          <ResultBadge result={oddsData.unover.home.result}>
            {oddsData.unover.home.result === "UNDER" && "언더"}
            {oddsData.unover.home.result === "OVER" && "오버"}
          </ResultBadge>
        )}
        <ToggleButton viewSub={viewSub} />
      </td>
    </tr>,
    viewSub && (
      <SubRow className={"subRow"} key={"subRow"}>
        <td colSpan={7}>
          <SubTableComp item={item} />
        </td>
      </SubRow>
    ),
  ];
};

const SubTableComp = ({ item }) => {
  const { home, away, oddsData, periodScore, totalScore } = item;

  return (
    <SubTable>
      <colgroup>
        <col width={127} />
        <col width={100} />
        <col width={100} />
        <col width={100} />
        <col width={60} />
        <col width={60} />
        <col width={60} />
        <col width={60} />
        <col width={60} />
      </colgroup>
      <thead>
        <tr>
          <th></th>
          <th>전반</th>
          <th>후반</th>
          <th>연장</th>
          <th>합계</th>
          <th>기준</th>
          <th>배당</th>
        </tr>
      </thead>
      <tbody>
        <TeamRow
          teamData={away}
          position={"AWAY"}
          detail={item}
          handi={oddsData.handicap.option}
          odds={oddsData.winLose.away ? oddsData.winLose.away.odds : null}
        />
        <TeamRow
          teamData={home}
          position={"HOME"}
          detail={item}
          handi={oddsData.unover.option}
          odds={oddsData.winLose.home ? oddsData.winLose.home.odds : null}
        />
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td>{periodScore[1] || 0}</td>
          <td>{periodScore[2] || 0}</td>
          <td>{periodScore[3] || 0}</td>
          <td>{totalScore}</td>
          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </SubTable>
  );
};

const TeamRow = ({ teamData, position, detail, handi, odds }) => {
  const { periodData, name } = teamData;
  let totalScore = 0;
  if (position === "HOME") {
    totalScore = detail.homeTotalScore;
  } else {
    totalScore = detail.awayTotalScore;
  }

  return (
    <tr>
      <th>{name}</th>
      <td>{(periodData[0] && periodData[0].score) || 0}</td>
      <td>{(periodData[1] && periodData[1].score) || 0}</td>
      <td>{(periodData[2] && periodData[2].score) || 0}</td>
      <td>{totalScore}</td>
      <td>{handi || "-"}</td>
      <td>{odds || "-"}</td>
    </tr>
  );
};

export default VSRecord;
